module.exports = __webpack_public_path__ + "img/dsj_py2.307d8892.png";